import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import { resetRendererModuleFailures } from "#/_packages/umbrella/integrations/umbraco/utils/renderer-module";
import { getRequestDiagnostic } from "#/_packages/umbrella/lib/orval/request-error.ts";
import DefaultError from "./default-error";

export function PageErrorFallback({
	error,
	resetErrorBoundary,
}: FallbackProps) {
	const diagnostic = getRequestDiagnostic(error);
	return (
		<DefaultError
			error={error}
			message={
				diagnostic ?? (error instanceof Error ? error.message : undefined)
			}
			onRetry={resetErrorBoundary}
		/>
	);
}

export default function PageErrorBoundary({ children }: PropsWithChildren) {
	const { reset } = useQueryErrorResetBoundary();
	return (
		<ErrorBoundary
			FallbackComponent={PageErrorFallback}
			onReset={() => {
				resetRendererModuleFailures();
				reset();
			}}
		>
			{children}
		</ErrorBoundary>
	);
}
